import React from 'react';
import { HTMLTemplate, TemplateData } from '@/lib/templates/htmlTemplates';
import { companyThemes } from '@/lib/templates/companyThemes';

interface TemplatePreviewProps {
  template: HTMLTemplate;
  className?: string;
}

const TemplatePreview: React.FC<TemplatePreviewProps> = ({ template, className = '' }) => {
  // 使用示例数据生成预览
  const sampleData: TemplateData = {
    title: '爆款标题',
    subtitle: '这是一个示例副标题内容',
    theme: companyThemes[0] // 使用第一个主题作为示例
  };

  const previewHtml = template.generate(sampleData);

  return (
    <div className={`template-preview ${className}`}>
      <div className="preview-container w-full h-full overflow-hidden">
        <iframe
          srcDoc={previewHtml}
          className="border-0"
          style={{
            width: '400px',
            height: '600px',
            transform: 'scale(0.25)',
            transformOrigin: 'top left',
            pointerEvents: 'none'
          }}
          title={`${template.name} 预览`}
        />
      </div>
    </div>
  );
};

export default TemplatePreview;
